import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import ReactSelect from "react-select/creatable";
import styled from "styled-components";
import { extractStylingProps } from "../../shared/propStyling/propStylingUtils";
import { useTombac } from "../../shared/tombac";
import { reactSelectStyles } from "./Select/reactSelectStyles";
import { reactSelectTheme } from "./Select/reactSelectTheme";
import { selectCss } from "./Select/selectCss";
function UnstyledSelect(props) {
  const tombac = useTombac();
  const [_, nonStylingProps] = extractStylingProps(props);
  return /*#__PURE__*/React.createElement(ReactSelect, _extends({
    createOptionPosition: "first",
    placeholder: "",
    theme: reactSelectTheme(tombac),
    styles: reactSelectStyles(tombac)
  }, nonStylingProps));
}
export const CreatableSelect = styled(UnstyledSelect).attrs(() => ({
  className: "TombacSelect TombacSelect--creatable"
})).withConfig({
  displayName: "CreatableSelect"
})(["", ""], selectCss);
//# sourceMappingURL=CreatableSelect.js.map